import AutoComplete from "components/AutoComplete";
import TableOnly from "components/DataTable/TableOnly";
import Pagination from "components/Pagination/Pagination";
import SearchComp from "components/SearchComp/SearchComp";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import DeleteModalButton from "components/DeleteModalBtn/DeleteModalButton";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";

let API_URL = "sales/products/fabrics";
let COMPONENT_URL = "/sales/products";
let COMPONENT_DETAILS_URL = "/sales/products";

let limits = [5, 10, 15, 20];

export default function SProductFabrics() {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();

  /*   ALL STATES
   ********************************************* */

  const [fabricsData, setFabricsData] = useState([]);
  const [searchResults, setSearchResults] = useState(null);

  const [totalPages, setTotalPages] = useState(
    parseInt(searchParams.get("totalPages")) || 1
  );
  if (searchParams.get("limit") === null) {
    setSearchParams((prev) => {
      let limit = searchParams.get("limit") || "10";
      const newParams = new URLSearchParams(prev);
      newParams.set("limit", limit);
      return newParams.toString();
    });
  }
  if (searchParams.get("page") === null) {
    setSearchParams((prev) => {
      let page = searchParams.get("page") || "1";
      const newParams = new URLSearchParams(prev);
      newParams.set("page", page);
      return newParams.toString();
    });
  }
  if (searchParams.get("filterBy") === null) {
    setSearchParams((prev) => {
      let filterBy = searchParams.get("filterBy") || "all";
      const newParams = new URLSearchParams(prev);
      newParams.set("filterBy", filterBy);
      return newParams.toString();
    });
  }

  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  const [loading, setLoading] = useState(false);

  /*   All Functions
   ********************************************* */

  const changeLimit = (val) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("limit", val);
      return newParams.toString();
    });
  };

  const getSearchParamsWithoutGivenKey = (key) => {
    let params = new URLSearchParams(searchParams);
    params.delete(key);
    return params.toString();
  };

  //get Data
  const getFabricsData = async () => {
    try {
      setLoading(true);

      let page = parseInt(searchParams.get("page")) || 1;
      let limit = parseInt(searchParams.get("limit")) || 10;
      let query = searchParams.get("query") || "";
      let filterBy = searchParams.get("filterBy") || "all";

      let body = { page, limit, filterBy };

      if (query) {
        body.query = query;
      }

      const { data } = await API.post(API_URL, body, {
        headers: authHeader(),
      });
      if (data.success) {
        setFabricsData(data.data);
        setTotalPages(data.totalPages);
        setSearchResults(null);
        return data.data;
      } else {
        dispatch(
          setNotification({
            message: data.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // AutoComplete Search Function
  const searchFabric = async (searchText, fieldName) => {
    try {
      setLoading(true);

      const { data } = await API.post(
        "/sales/products/fabrics/auto-complete",
        { searchText, fieldName },
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        return data?.data;
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // Delete
  const deleteFabricsData = async (id) => {
    try {
      setLoading(true);
      const { data } = await API.delete("/sales/products/fabric/" + id, {
        headers: authHeader(),
      });
      if (data?.success) {
        // setFabricsData((prev) => prev.filter((item) => item.id !== id));
        await getFabricsData();
        dispatch(
          setNotification({
            message: data?.message,
            type: "success",
          })
        );
        return;
      }
      dispatch(
        setNotification({
          message: data?.message,
          type: "error",
        })
      );
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // Adds Button Function
  const AddFabricsData = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await API.post("/sales/products/fabric", formData, {
        headers: authHeader(),
      });
      if (data?.success) {
        // setFabricsData((prev) => [...prev, data?.data]);
        await getFabricsData();
        setFormData({});
        setShowAddModal(false);
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }

    setShowAddModal(false);
  };

  // Update Button Function
  const UpdateFabricsData = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await API.patch("/sales/products/fabric", formData, {
        headers: authHeader(),
      });
      if (data?.success) {
        // setFabricsData((prev) => {
        //   const newData = prev.map((item) => {
        //     if (item.id === formData.id) {
        //       return data?.data;
        //     }
        //     return item;
        //   });
        //   return newData;
        // });
        await getFabricsData();
        setIsUpdateMode(false);
        setShowAddModal(false);
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateData = async (item) => {
    setFormData(item);
    setIsUpdateMode(true);
    setShowAddModal(true);
  };

  // Sorting Up
  const sortUp = async (id) => {
    const index = fabricsData.findIndex((item) => item.id === id);
    if (index === -1) return;
    if (index === 0) return;
    if (index === fabricsData.length) return;

    const currentSortId = fabricsData[index]?.sortId;
    const currentId = fabricsData[index]?.id;
    const upSortId = fabricsData[index - 1].sortId;
    const upId = fabricsData[index - 1].id;
    try {
      const { data } = await API.post(
        "sales/products/fabric/sortup",
        { currentSortId, currentId, upSortId, upId },
        { headers: authHeader() }
      );
      if (data.success) {
        await getFabricsData();
      }
    } catch (err) {
      alert(err.message);
    }
  };

  // Sorting Up
  const sortDown = async (id) => {
    const index = fabricsData.findIndex((item) => item.id === id);
    if (index === -1) return;
    if (index === fabricsData.length - 1) return;

    const currentSortId = fabricsData[index]?.sortId;
    const currentId = fabricsData[index]?.id;
    const downSortId = fabricsData[index + 1].sortId;
    const downId = fabricsData[index + 1].id;

    try {
      const { data } = await API.post(
        "sales/products/fabric/sortDown",
        { currentSortId, currentId, downSortId, downId },
        { headers: authHeader() }
      );
      if (data.success) {
        await getFabricsData();
      }
    } catch (err) {
      alert(err.message);
    }
  };

  useEffect(() => {
    let timeout = setTimeout(() => {
      let _filterBy = searchParams.get("filterBy") || "all";
      let _query = searchParams.get("query") || "";
      if (_filterBy && _filterBy !== "all" && !_query) {
        return;
      }
      getFabricsData();
    }, 50);
    return () => clearTimeout(timeout);
  }, [searchParams]);

  /*   Table functions
   ********************************************* */
  const btn1 = () => (
    <div>
      <>
        <button
          onClick={() => {
            setShowAddModal(true);
            setFormData({});
            setIsUpdateMode(false);
          }}
          type="button"
          className="btn btn-primary  ms-1"
        >
          Add Fabric
        </button>
      </>
    </div>
  );

  const table_head = [
    { name: "ID", value: "fabricId" },
    { name: "Fabric Name", value: "name" },
    { name: "Actions", value: "Actions" },
  ];

  const table_body = (item, index) => (
    <tr className="" key={item.id}>
      <td className="py-0 align-middle">{item.fabricId}</td>
      <td className="py-0 align-middle">{item.name}</td>

      <td className="py-0 align-middle table-action">
        <button
          onClick={() => {
            item.sort_id !== 1 && sortUp(item?.id);
          }}
          disabled={item.sort_id === 1}
          className="action-icon border-0 btn"
        >
          <i className="mdi mdi-chevron-double-up"></i>
        </button>
        <button
          onClick={() => {
            item.sort_id !== fabricsData.length && sortDown(item?.id);
          }}
          disabled={item.sort_id === fabricsData.length}
          className="action-icon border-0 btn"
        >
          <i className="mdi mdi-chevron-double-down"></i>
        </button>
        <button
          disabled={loading}
          onClick={() => {
            handleUpdateData(item);
          }}
          className="btn px-1"
        >
          <i className="mdi mdi-pencil"></i>
        </button>

        <DeleteModalButton
          btnClass={"btn  px-1"}
          deleteFunc={deleteFabricsData}
          deleteParams={item.id}
          disableConditions={loading}
        />
      </td>
    </tr>
  );

  return (
    <div className="p-2" style={{ height: "100vh" }}>
      {loading && <Spinner />}
      {/*   Table
       ********************************************* */}
      <div className="px-2">
        <div className="">
          <div className="">
            <div className="d-flex justify-content-end align-items-center gap-1 mb-3">
              <div className="flex-grow-1 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-1">
                  <div>Show</div>
                  <button
                    className="px-1 bg-primary bg-opacity-10 border border-primary rounded-end rounded-start "
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {searchParams.get("limit")}
                  </button>
                  <ul
                    style={{ width: "fit-content" }}
                    className="dropdown-menu"
                  >
                    {limits.map((limit) => (
                      <li key={limit}>
                        <button
                          className="dropdown-item"
                          onClick={() => changeLimit(limit)}
                        >
                          {limit}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <SearchComp
                setLoading={setLoading}
                apiPath={`${COMPONENT_URL}${
                  getSearchParamsWithoutGivenKey("query")
                    ? "?" + getSearchParamsWithoutGivenKey("query") + "&"
                    : "?"
                }`}
              />
              <div className="">{btn1()}</div>
            </div>

            <div
              className="mb-3"
              style={{ height: "75vh", overflowY: "auto", borderRadius: 15 }}
            >
              {searchResults ? (
                <TableOnly
                  table_head={table_head}
                  table_body={table_body}
                  table_data={searchResults}
                  totalPages={totalPages}
                />
              ) : (
                <TableOnly
                  table_head={table_head}
                  table_body={table_body}
                  table_data={fabricsData}
                  totalPages={totalPages}
                />
              )}
            </div>
            {loading && <Spinner />}
            {!searchResults && (
              <Pagination
                totalPages={totalPages}
                apiPath={`${COMPONENT_URL}${
                  searchParams.toString()
                    ? "?" + getSearchParamsWithoutGivenKey("page") + "&"
                    : "?"
                }page=`}
                currPage={parseInt(searchParams.get("page")) || 1}
              />
            )}
          </div>
        </div>
      </div>
      {/*   ADD Modal
       ********************************************* */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
        <Modal.Body
          className="shadow-lg bg-white px-3 "
          style={{ borderRadius: 15 }}
        >
          <form
            onSubmit={isUpdateMode ? UpdateFabricsData : AddFabricsData}
            className=""
          >
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h4>{isUpdateMode ? "Update Fabric" : "Add Fabric"}</h4>
              {/*   buttons
               ********************************************* */}
              <div className="">
                <div className="d-flex justify-content-end">
                  <button
                    onClick={() => {
                      setShowAddModal(false);
                    }}
                    className="btn btn-secondary btn-sm"
                    type="button"
                  >
                    Close
                  </button>
                  <button
                    disabled={loading}
                    className="btn btn-primary btn-sm ms-1"
                    type="submit"
                  >
                    {isUpdateMode ? "Update" : "Add"}
                  </button>
                </div>
              </div>
            </div>
            <hr className="mt-0" />
            <div className="mt-2 mb-3">
              <label htmlFor="name">Fabric Name</label>
              <AutoComplete
                fieldName={"name"}
                value={formData?.name || ""}
                handleChange={(key, value) => {
                  setFormData({ ...formData, [key]: value });
                }}
                searchFunction={searchFabric}
                placeholder={"Enter Fabric Name"}
                required
                classNames={"form-control"}
              />
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
}
